import { VisibleCategories } from '@/types';

const areAllCategoriesVisible = (visibleCategories: VisibleCategories): boolean => {
  return Object.values(visibleCategories).every((category) => category.visible);
};
const areAnyCategoriesVisible = (visibleCategories: VisibleCategories): boolean => {
  return Object.values(visibleCategories).some((category) => category.visible);
};
const toggleAllCategories = (
  visibleCategories: VisibleCategories,
  visible: boolean
): VisibleCategories => {
  const updatedCategories = { ...visibleCategories };

  Object.keys(updatedCategories).forEach((key) => {
    updatedCategories[key as keyof VisibleCategories] = {
      ...updatedCategories[key as keyof VisibleCategories],
      visible,
    };
  });

  return updatedCategories;
};

export { areAllCategoriesVisible, areAnyCategoriesVisible, toggleAllCategories };
